import { useCallback, useRef, useState } from "react";
import { info } from "../../services/sentryLogger";

export type HistPos = { topId: string; bottomId: string }

export const useBinarySwap = () => {
    const prevStms = useRef<HistPos | null>(null)
    const [currentPos, setCurrentPos] = useState<HistPos | null>(null)

    const swapIfNeeded = useCallback( (targetPos: HistPos) => {
        const newPos = {...targetPos};
        if (prevStms.current) {
            const prevPos = prevStms.current
            // FIXME
            if(prevPos.topId === targetPos.topId && prevPos.bottomId === targetPos.bottomId) {
                info('swapIfNeeded', '2nd rendering, no swap needed')
                return;
            }
            if (
                prevPos.topId === targetPos.topId ||
                prevPos.bottomId === targetPos.bottomId
            ) {
                newPos.bottomId = targetPos.topId
                newPos.topId = targetPos.bottomId
            }
        }
        prevStms.current = newPos
        setCurrentPos(newPos)
    }, [])

    return {
        swapIfNeeded,
        currentPos,
    }
}